import type { Node as ProsemirrorNode } from 'prosemirror-model';
import type { ResizableProps } from 're-resizable';
import { Resizable } from 're-resizable';
import { useState } from 'react';
import {
	EMBED_HEIGHT,
	EMBED_WIDTH,
	MAX_EMBED_HEIGHT,
	MAX_EMBED_WIDTH,
} from './Embed.constants';

interface ResizeBoxProps {
	node: ProsemirrorNode;
	handleResize: ({
		node,
		size,
	}: {
		node: ProsemirrorNode;
		size: {
			width: number;
			height: number;
		};
	}) => boolean;
	readOnly?: boolean;
	defaultWidth: number;
	defaultHeight: number;
	handleSelect: ResizableProps['onResizeStart'];
	children: React.ReactNode;
}

export default function ResizeBox({
	handleSelect,
	children,
	node,
	handleResize,
	readOnly,
	defaultWidth,
	defaultHeight,
}: ResizeBoxProps) {
	const [width, setWidth] = useState(defaultWidth || EMBED_WIDTH);
	const [height, setHeight] = useState(defaultHeight || EMBED_HEIGHT);

	return (
		<Resizable
			size={{ width, height }}
			maxWidth={MAX_EMBED_WIDTH}
			maxHeight={MAX_EMBED_HEIGHT}
			onResizeStart={handleSelect}
			enable={{
				top: !readOnly,
				right: !readOnly,
				bottom: !readOnly,
				left: !readOnly,
				topRight: !readOnly,
				bottomRight: !readOnly,
				bottomLeft: !readOnly,
				topLeft: !readOnly,
			}}
			onResizeStop={(e, direction, ref) => {
				if (readOnly) return;
				setWidth(ref.clientWidth);
				setHeight(ref.clientHeight);

				handleResize({
					node,
					size: {
						width: ref.clientWidth,
						height: ref.clientHeight,
					},
				});
			}}
		>
			{children}
		</Resizable>
	);
}
